/**
 * Gym stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_stickers`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const gymStickersPack: ToilePack = {
    slug: 'gym-stickers',
    category: 'sticker',
    name: 'Gym stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'dumbbell', label: 'Dumbbell', subject: 'a single dumbbell'},
        {key: 'kettlebell', label: 'Kettlebell', subject: 'a kettlebell with a handle'},
        {key: 'shaker', label: 'Shaker bottle', subject: 'a protein shaker bottle with a lid'},
    ],
    styles: [
        {key: 'retro', label: 'Retro', style: 'retro sticker illustration, 1970s shapes, halftone grain, slight misregistration', palette: 'Mustard, rust, teal and cream', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'bold', label: 'Bold cartoon', style: 'bold cartoon sticker, thick black outlines, bright flat fills, slight gloss', palette: 'Bright saturated primaries with black outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'minimal', label: 'Minimal line', style: 'minimal single-line sticker, one clean continuous line, no fill', palette: 'Black line only, one accent colour', framing: 'Each sticker isolated with a thin white die-cut border on a plain ground'},
    ],
    directions: ['a yoga mat instead', 'for a water bottle', 'for a gym bag'],
    directionHint: 'try: a yoga mat instead',
    seo: {
        title: 'Gym Stickers: Dumbbell, Kettlebell, Shaker',
        metaDescription: 'Nine gym stickers — a dumbbell, a kettlebell, a shaker bottle — in retro, bold cartoon, and minimal line styles.',
        h1: 'Gym stickers: dumbbell, kettlebell, shaker bottle',
        tagline: 'Nine stickers, three gym icons, three styles each.',
        intro: 'A single dumbbell, a kettlebell with a handle, and a protein shaker bottle with a lid — three gym stickers, die-cut and ready to print. Each rendered retro, bold cartoon, and minimal single-line. Ask for a barbell instead, a running-shoe scene, or a whole gym-bag composition, and the same three styles carry it.',
        useCases: [
            'a water bottle or gym bag',
            'a fitness planner or journal',
            'a laptop or phone case',
            'a motivational wall print',
        ],
        faq: [
            {q: "What's in this pack?", a: 'Nine gym stickers — a dumbbell, a kettlebell, and a shaker bottle — in retro, bold cartoon, and minimal line finishes.'},
            {q: 'Can I get a barbell or a different gym item?', a: 'Yes — the direction field takes any variation, including a barbell instead, a running-shoe scene, or a whole gym-bag composition.'},
            {q: 'What size should I print these at?', a: 'Each sticker is a square die-cut design, so it scales cleanly from a small vinyl sticker to a full A4 sheet.'},
            {q: 'Do these carry a gym or brand logo?', a: 'No — every sticker is a generic, original illustration with no brand name or logo.'},
        ],
    },
}
